"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "23", height: "19", viewBox: "0 0 23 19", className: "Icon nav-notifications", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "#777", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M4.862 4.775a2.666 2.666 0 0 1 2.663-2.662 2.665 2.665 0 0 1 2.662 2.662 2.666 2.666 0 0 1-2.662 2.663 2.667 2.667 0 0 1-2.663-2.663M7.525 8.7a3.93 3.93 0 0 0 3.925-3.925A3.93 3.93 0 0 0 7.525.85 3.93 3.93 0 0 0 3.6 4.775 3.928 3.928 0 0 0 7.525 8.7M15.063 7.325a1.813 1.813 0 0 1 3.624 0 1.813 1.813 0 0 1-3.624 0m1.812 3.075a3.078 3.078 0 0 0 3.076-3.075 3.078 3.078 0 0 0-3.076-3.075A3.079 3.079 0 0 0 13.8 7.325a3.079 3.079 0 0 0 3.075 3.075M14.565 13.393c.201-.042.4-.077.632-.11a12.04 12.04 0 0 1 1.678-.12c.547 0 1.112.04 1.677.12.384.054.595.101.657.115 1.118.185 2.028 1.223 2.028 2.314v1.017c0 .033-.027.059-.063.059h-6.369c.027-.118.045-.24.045-.366V14.89c0-.516-.104-1.02-.285-1.497zm-2.053 3.336v-1.017c0-.672.365-1.346.896-1.794.11.314.178.641.178.972v1.532a.364.364 0 0 1-.369.366h-.642c-.034 0-.063-.027-.063-.059zm-8.114-5.072l.085-.039a3.86 3.86 0 0 1 .336-.051c.607-.069 1.517-.104 2.705-.104 1.19 0 2.1.035 2.705.104.156.018.267.036.315.043l.07.034.191.032c.764.109 1.465.542 1.974 1.139-.909.672-1.529 1.755-1.529 2.897v1.017c0 .021.01.038.011.059H1.833a.369.369 0 0 1-.37-.366V14.89c0-1.547 1.266-3.018 2.766-3.212l.17-.021zm15.09.51a12.873 12.873 0 0 0-2.613-.267c-1.45 0-2.603.264-2.607.266-.116.018-.226.057-.34.088-.707-.951-1.752-1.653-2.933-1.826-.109-.04-.766-.228-3.47-.228-2.7 0-3.358.187-3.47.228C1.928 10.709.2 12.708.2 14.89v1.532c0 .898.732 1.628 1.633 1.628h19.341c.731 0 1.327-.593 1.327-1.321v-1.017c0-1.684-1.355-3.274-3.013-3.545z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/nav-notifications.js
// module id = 1868
// module chunks = 0